export const SCROLL_CONTAINER_MAIN_PROJECT = 'scroll-container-main'
export const SCROLL_CONTAINER_FORM = 'scroll-container-form'
export const SCROLL_CONTAINER_CALENDAR = 'scroll-container-calendar'
